import React from "react"
import styled from "styled-components"
import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/router"

import share from "@/common/assets/image/social/share.svg"
import backIcon1 from "@/common/assets/image/social/backIcon1.svg"
import backIcon2 from "@/common/assets/image/social/backIcon2.svg"
import FB1 from "@/common/assets/image/social/FB.svg"
import FB2 from "@/common/assets/image/social/FB2.svg"
import Twiter1 from "@/common/assets/image/social/Twiter.svg"
import Twiter2 from "@/common/assets/image/social/Twiter2.svg"
import linked1 from "@/common/assets/image/social/linkedin.svg"
import linked2 from "@/common/assets/image/social/linkedin2.svg"

export default function ArticleHeader({ shareTitle }) {
  const { locale } = useRouter()
  const Router = useRouter()
  return (
    <Wrapper>
      <BackIconWrapper>
        <Link href={`/${locale}/blog`} passHref legacyBehavior>
          <ImageWrapper>
            <Image
              src={backIcon2}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
            <Image
              src={backIcon1}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
          </ImageWrapper>
        </Link>
      </BackIconWrapper>
      <ShareIconsWrapper>
        <ImageWrapper>
          <Image
            src={share}
            alt="back"
            fill
            sizes="100vw"
            style={{
              objectFit: "cover"
            }}
          />
        </ImageWrapper>
        <a
          href={`https://www.facebook.com/sharer.php?u=https://www.kryptogo.com/${locale}${Router.asPath}`}
          target="blank"
        >
          <ImageWrapper>
            <Image
              src={FB2}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
            <Image
              src={FB1}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
          </ImageWrapper>
        </a>
        <a
          href={`https://twitter.com/share?text=${shareTitle}&url=https://www.kryptogo.com/${locale}${Router.asPath}`}
          target="blank"
        >
          <ImageWrapper>
            <Image
              src={Twiter2}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
            <Image
              src={Twiter1}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
          </ImageWrapper>
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?mini=true＆title=${shareTitle}&url=https://www.kryptogo.com/${locale}${Router.asPath}`}
          target="blank"
        >
          <ImageWrapper>
            <Image
              src={linked2}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
            <Image
              src={linked1}
              alt="back"
              fill
              sizes="100vw"
              style={{
                objectFit: "cover"
              }}
            />
          </ImageWrapper>
        </a>
      </ShareIconsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 30px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`
const BackIconWrapper = styled.div`
  overflow: hidden;
  cursor: pointer;
  > div {
    span {
      transition: 0.5s;
    }
    span:nth-child(1) {
      translate: 50px;
    }
  }
  &:hover {
    > div {
      span:nth-child(1) {
        translate: 0px;
      }
      span:nth-child(2) {
        translate: -50px;
      }
    }
  }
`
const ShareIconsWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 24px;
  transition: all 0.3s;
  overflow: hidden;
  /* padding-left: 50px; */
  &:hover {
    width: 132px;
    > div:nth-child(1) {
      opacity: 0;
    }
  }
`
const ImageWrapper = styled.div`
  flex: 0 1 24px;
  min-width: 24px;
  height: 24px;
  position: relative;
  transition: 0.3s;
  cursor: pointer;
  span {
    transition: all 0.3s;
  }
  &:hover {
    span:nth-child(2) {
      opacity: 0 !important;
    }
  }
`
